exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message-title[data-v-cf51e862] {\r\n  font-size: 16px;\r\n  color: #333;\r\n  font-weight: bold;\r\n  padding-right: 8px;\n}\r\n", ""]);

// exports
